<template>
  <ul class="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
    <li class="nav-item" v-for="(item,idx) in tabs" :key="idx">
      <a :class="selected==item.id?'nav-link active':'nav-link'" data-bs-toggle="tab" role="tab" aria-selected="true" @click="selected=item.id">
        <span class="d-none d-sm-block">{{item.name}}</span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: null
    },
    value: {
      type: Number,
      default: 0
    }
  },
  methods: {

  },
  created() {
    this.selected = this.value
  },
  mounted() {
  },
  watch:{
    selected:function () {
      this.$emit('input', this.selected)
    }
  },
  data() {
    return {
      selected: 0,
    }
  }
}
</script>